var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useState } from 'react';
import { Container, ContainerDisplays, ContainerFlexAlignItems, ContainerFlexDirections, ContainerFlexGaps, ContainerFlexJustifyContents, ContainerPaddings, ContainerWidths } from '../../../templates/container';
import { ThemeUtils, getAttributes } from '../../../../utils';
import { Button, ButtonVariants, ButtonWidths } from '../../../atoms/button';
import { Icon, IconSizes, IconStates } from '../../../atoms/icon';
import { Image } from '../../../atoms/image';
import { Text, TextVariants } from '../../../atoms/text';
import { Popover, PopoverBorderStyles } from '../../../templates/popover';
import { ProductChips } from '../common/product-chips';
import { PriceInfo } from '../common/price-info';
import { IconButton, IconButtonSize, IconButtonStyles } from '../../../atoms/icon-button';
import { PopoverBackgroundVariants } from '../../../templates/popover/types';
var MC = function (_a) {
    var _b, _c;
    var props = __rest(_a, []);
    var popoverProps = props.popoverProps, title = props.title, productChipsProps = props.productChipsProps, priceInfoProps = props.priceInfoProps, productImageProps = props.productImageProps, productName = props.productName, productVariantName = props.productVariantName, productQuantity = props.productQuantity, productQuantityLabel = props.productQuantityLabel, actions = props.actions, _d = props.idleCloseTimeout, idleCloseTimeout = _d === void 0 ? 5000 : _d, _e = props.blurCloseTimeout, blurCloseTimeout = _e === void 0 ? 3000 : _e, onClose = props.onClose, ariaLabel = props["aria-label"], rest = __rest(props, ["popoverProps", "title", "productChipsProps", "priceInfoProps", "productImageProps", "productName", "productVariantName", "productQuantity", "productQuantityLabel", "actions", "idleCloseTimeout", "blurCloseTimeout", "onClose", 'aria-label']);
    var _f = useState(0), focusCount = _f[0], setFocusCount = _f[1];
    var _g = useState(false), focusIn = _g[0], setFocusIn = _g[1];
    var focusCountRef = React.useRef(focusCount);
    var focusInRef = React.useRef(focusIn);
    focusCountRef.current = focusCount;
    focusInRef.current = focusIn;
    useEffect(function () {
        if (popoverProps === null || popoverProps === void 0 ? void 0 : popoverProps.open) {
            if (idleCloseTimeout > 0) {
                setTimeout(function () {
                    if ((focusCountRef === null || focusCountRef === void 0 ? void 0 : focusCountRef.current) === 0) {
                        onClose === null || onClose === void 0 ? void 0 : onClose(null);
                    }
                }, idleCloseTimeout);
            }
        }
    }, [popoverProps === null || popoverProps === void 0 ? void 0 : popoverProps.open]);
    var containerConfig = {
        padding: ContainerPaddings.Size_4,
        display: ContainerDisplays.Flex,
        flexGap: ContainerFlexGaps.Size_5,
        flexDirection: ContainerFlexDirections.Column
    };
    var titleContainerConfig = {
        display: ContainerDisplays.Flex,
        flexDirection: ContainerFlexDirections.Row,
        flexGap: ContainerFlexGaps.Size_3,
        flexJustifyContent: ContainerFlexJustifyContents.SpaceBetween,
        flexAlignItems: ContainerFlexAlignItems.Start
    };
    var titleMainContainerConfig = {
        display: ContainerDisplays.Flex,
        flexDirection: ContainerFlexDirections.Row,
        flexGap: ContainerFlexGaps.Size_2
    };
    var iconConfig = {
        image: 'pmi-icon-check-full',
        size: IconSizes.Small,
        state: IconStates.Success
    };
    var titleConfig = {
        content: "<b>".concat(title, "</b>"),
        isHtml: true
    };
    var closeIconConfig = {
        icon: 'pmi-icon-cancel',
        size: IconButtonSize.Small,
        style: IconButtonStyles.Empty,
        onClick: function (event) {
            if (onClose) {
                onClose(event);
            }
        },
        'aria-label': ariaLabel
    };
    var productContainerConfig = {
        display: ContainerDisplays.Flex,
        flexDirection: ContainerFlexDirections.Row,
        flexGap: ContainerFlexGaps.Size_2,
        width: ContainerWidths.Full
    };
    var productImageConfig = __assign({}, productImageProps);
    var productInfoConfig = {
        display: ContainerDisplays.Flex,
        flexDirection: ContainerFlexDirections.Column,
        width: ContainerWidths.Full
    };
    var productNameConfig = {
        content: "<b>".concat(productName, "</b>"),
        isHtml: true
    };
    var productVariantNameConfig = {
        content: productVariantName
    };
    var priceConfig = {
        reverse: true,
        currentPriceTextProps: __assign(__assign({ variant: TextVariants.Body1 }, priceInfoProps === null || priceInfoProps === void 0 ? void 0 : priceInfoProps.currentPriceTextProps), { isHtml: true, content: "<b>".concat((_b = priceInfoProps === null || priceInfoProps === void 0 ? void 0 : priceInfoProps.currentPriceTextProps) === null || _b === void 0 ? void 0 : _b.content, "</b>") }),
        originalPriceTextProps: __assign({ variant: TextVariants.Body2 }, priceInfoProps === null || priceInfoProps === void 0 ? void 0 : priceInfoProps.originalPriceTextProps)
    };
    var productDetailsContainerConfig = {
        display: ContainerDisplays.Flex,
        flexDirection: ContainerFlexDirections.Row,
        flexJustifyContent: ContainerFlexJustifyContents.SpaceBetween,
        flexAlignItems: ContainerFlexAlignItems.End,
        flexGap: ContainerFlexGaps.Size_2
    };
    var productQuantityConfig = {
        content: "".concat(productQuantityLabel, " ").concat(productQuantity)
    };
    var productPriceContainerConfig = {
        flexShrink: 0
    };
    var chipsContainerConfig = {
        padding: ThemeUtils.getResponsiveProp([
            {
                b: ContainerPaddings.Size_3
            }
        ])
    };
    var productChipsComponent = productChipsProps && ((_c = productChipsProps === null || productChipsProps === void 0 ? void 0 : productChipsProps.chipPropsList) === null || _c === void 0 ? void 0 : _c.length) ? (React.createElement(Container, __assign({}, chipsContainerConfig),
        React.createElement(ProductChips, { chipPropsList: productChipsProps === null || productChipsProps === void 0 ? void 0 : productChipsProps.chipPropsList }))) : null;
    var actionConfig = {
        buttonWidth: ButtonWidths.Full
    };
    var actionsComponent = actions && (actions === null || actions === void 0 ? void 0 : actions.length) ? (React.createElement(Text.TextSection, null, actions.map(function (action, actionIndex) { return (React.createElement(Button, __assign({ key: "mini-cart-action-".concat(actionIndex) }, __assign(__assign({}, actionConfig), { buttonVariant: actionIndex === 0
            ? ButtonVariants.Contained
            : ButtonVariants.Outlined }), action))); }))) : null;
    var popoverConfig = __assign(__assign({ borderStyle: PopoverBorderStyles.NoBorder, fullWidth: ThemeUtils.getResponsiveCurrentValue([true, false]) || false, noMargin: true, backdrop: true, onClose: onClose, background: PopoverBackgroundVariants.Alternative, onMouseEnter: blurCloseTimeout > 0
            ? function () {
                setFocusCount((focusCountRef === null || focusCountRef === void 0 ? void 0 : focusCountRef.current) + 1);
                setFocusIn(true);
            }
            : undefined, onMouseLeave: blurCloseTimeout > 0
            ? function () {
                setTimeout(function () {
                    if (focusCount === (focusCountRef === null || focusCountRef === void 0 ? void 0 : focusCountRef.current) &&
                        !(focusInRef === null || focusInRef === void 0 ? void 0 : focusInRef.current)) {
                        onClose === null || onClose === void 0 ? void 0 : onClose(null);
                    }
                }, blurCloseTimeout);
                setFocusIn(false);
            }
            : undefined, 'aria-live': 'polite', 'aria-relevant': 'additions' }, popoverProps), getAttributes(rest));
    return (React.createElement(Popover, __assign({}, popoverConfig),
        React.createElement(Container, __assign({}, containerConfig),
            React.createElement(Container, __assign({}, titleContainerConfig),
                React.createElement(Container, __assign({}, titleMainContainerConfig),
                    React.createElement(Icon, __assign({}, iconConfig)),
                    React.createElement(Text, __assign({}, titleConfig))),
                React.createElement(IconButton, __assign({}, closeIconConfig))),
            React.createElement(Container, __assign({}, productContainerConfig),
                React.createElement(Image, __assign({}, productImageConfig)),
                React.createElement(Container, __assign({}, productInfoConfig),
                    productChipsComponent,
                    React.createElement(Text, __assign({}, productNameConfig)),
                    React.createElement(Text, __assign({}, productVariantNameConfig)),
                    React.createElement(Container, __assign({}, productDetailsContainerConfig),
                        React.createElement(Text, __assign({}, productQuantityConfig)),
                        React.createElement(Container, __assign({}, productPriceContainerConfig),
                            React.createElement(PriceInfo, __assign({}, priceConfig)))))),
            actionsComponent)));
};
export { MC as MiniCart };
